import React from "react"
import FeaturedEvent from "./featuredEvent"
import EventSummary from "./eventSummary"
import Grid from "@material-ui/core/Grid";
import EventsStyles from "./events.styles";
import Box from '@material-ui/core/Box';
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";

export const Events = ({ events }) => {
    const classes = EventsStyles();

    const featured = events && events.length > 0 ? events[0] : null;
    const upcoming = events && events.length > 0 ? events.slice(1) : [];
    return (
        <div>
            <Box className={classes.header}>
                <Link href="/events/" color="inherit">
                    <div><Typography variant="h4">Calender</Typography></div>
                    <div className={classes.subtitle}>see all events</div>
                </Link>
            </Box>
            {featured && <FeaturedEvent event={featured} />}

            <Grid container className={classes.summaryGridPadding}>
                {upcoming.map((post) => (
                    <Grid item xs={12} lg={6} key={post.id}>
                        <EventSummary key={post.id} event={post} />
                    </Grid>
                ))}
            </Grid>

        </div>
    );
}

Events.NAME = "Events";
export default Events
